import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getBackofficeCompaniesQueryKey } from "modules/backoffice/lib/companies/getBackofficeCompaniesQuery"
import {
  BackofficeCreateCompanyResponseDataSchema,
  CreateBackofficeCompanyFromWebsiteBodySchema,
  DataResponse,
} from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof BackofficeCreateCompanyResponseDataSchema>>

type Props = {
  onSuccess?: () => void
}

export function useCreateBackofficeCompanyFromWebsiteMutation({ onSuccess }: Props = {}) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.infer<typeof CreateBackofficeCompanyFromWebsiteBodySchema>) => {
      const response = await axios.post<Response>(`/backoffice/companies/from-website`, data)

      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getBackofficeCompaniesQueryKey() })

      onSuccess?.()
    },
  })
}
